import React from "react"
import ReactSearchBox from "react-search-box"

import "./_main-navigation.scss"

import Playlist from "../playlist"
import { data } from "../country-playlist"
import Logo from "../logo"

import hamburger from "../../assets/images/hamburger.svg"

const MainNavigation = ({
  toggleMenu,
  isMenuOpen,
  countryCode,
  setCountryCode,
}) => {
  return (
    <div className="main-navigation">
      <div className="main-navigation__logo">
        <Logo />
      </div>

      <div className="main-navigation__search">
        <ReactSearchBox
          inputBoxHeight="5vh"
          dropDownHoverColor="#D3D3D3"
          placeholder="Search by country"
          data={data}
          onSelect={record => setCountryCode(record.alpha2)}
        />
      </div>
      <button
        className={`main-navigation__btn ${
          isMenuOpen && "main-navigation__btn--open"
        }`}
        type="button"
        onClick={toggleMenu}
      >
        <img src={hamburger} alt="navbar" />
      </button>

      <div className="main-navigation__playlist">
        <Playlist
          country={countryCode}
          toggleMenu={toggleMenu}
          isMenuOpen={isMenuOpen}
        />
      </div>
    </div>
  )
}

export default MainNavigation
